<template>
    <div>
        <b-table hover small show-empty class="sr-caption"
                 :id="slug"
                 responsive="true"
                 :fields="fields"
                 :items="documents"
                 :busy="isLoading"
                 label-sort-asc=""
                 label-sort-desc=""
                 :caption="documentTypeName + ' Document table.  To sort the data in this table by a specific column, go to the appropriate ' +
                  'column header cell and use enter to sort the data ascending.  Use enter again to sort descending.'">
            <template v-slot:no-data>
                No documents attached.
            </template>
            <div slot="table-busy" className="text-center text-danger my-2">
                <b-spinner className="align-middle"></b-spinner>
                <strong>Loading...</strong>
            </div>
            <template v-slot:cell(createdDate)="row">
                {{momentFormat(row.item.createdDate)}}
            </template>
            <template v-slot:cell(actions)="row">
                <b-button size="sm" @click="download(row.item)" target="_attach" class="mr-1">
                    Download
                </b-button>
                <b-button size="sm" @click="deleteDocument(row.item)" class="mr-1" v-if="!isView">
                    Delete
                </b-button>
            </template>
            <template slot="empty" slot-scope="scope">
                No documents attached.
            </template>
        </b-table>
    </div>
</template>

<script>
    import axios from 'axios'
    import axiosRetry from 'axios-retry'
    import * as FileSaver from 'file-saver';
    import DocumentService from '@/services/DocumentService';
    import ConfigService from "@/services/ConfigService";
    import moment from 'moment';

    axiosRetry(axios, { retries: 3,
        retryDelay: axiosRetry.exponentialDelay  })

export default {
    components: {
    },
    props: {
        slug: [String],
        newDoc: [Array],
        applicationId: [String],
        documentTypeId: [String],
        documentTypeName: [String],
        isView: [Boolean],
    },
    data: () => ({
        fields: [
            {key: 'name', sortable: true, label: 'File Name'},
            {key: 'createdDate', sortable: true, label: 'Date Uploaded'},
            {key: 'actions', label: 'Actions'}
        ],
        isLoading: false,
        documents: [],
    }),
    created () {
        this.initialize()
    },
    methods: {
        initialize() {
            this.isLoading = true
            const payload = {
                documentTypeId: this.documentTypeId
            }
            axios.get(ConfigService.getApiUrl() + `/api/applications/`+ this.applicationId + "/documents", {params: payload})
                .then(response => {
                    this.documents = response.data
                    this.updateEmit()
                    this.isLoading = false
                })
        },
        deleteDocument(doc) {
            axios.delete(ConfigService.getApiUrl() + `/api/applications/`+ this.applicationId + '/documents/' + doc.id )
                .then(response => {
                    const index = this.documents.findIndex(d => doc.id === d.id)
                    this.documents.splice(index ,1)
                    this.updateEmit()
                })
        },
        download(doc){
            axios.get(ConfigService.getApiUrl() + `/api/applications/`+ this.applicationId + '/documents/' + doc.id, {
                responseType: 'arraybuffer'
            }).then(data => {
                const blob = DocumentService.convertToBlob(data.data, data.headers["content-type"])
                FileSaver.saveAs(blob, doc.name);
            })
        },
        updateEmit() {
            this.$emit("document-updated", this.documents)
        },
        momentFormat(date) {
            return moment(date).format("MM/DD/YYYY")
        },
    },
    watch: {
        newDoc() {
            if (this.newDoc.length > 0) {
                this.newDoc.forEach(doc => this.documents.push(doc))
                this.updateEmit()
            }
        },
    }
}
</script>